import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import ModalActionsFooter from '../ModalActionsFooter/ModalActionsFooter'
import { getCustomModalContentStyle } from './customModal.constants'
import './customModal.css'

const SIZE_CLASS = {
  tiny: 'custom-modal--tiny',
  small: 'custom-modal--small',
  large: 'custom-modal--large',
}

const CustomModal = ({
  open,
  onClose,
  title,
  content,
  onConfirm,
  confirmLabel,
  confirmDisabled,
  isLoading = false,
  size = 'tiny',
  cancelarLabel = 'Cancelar',
  classNameContent,
  classNameModal,
  classNamePortal,
  modalStyle,
  customActions,
  classNameActions,
  hideActions = false,
  hideHeader = false,
  confirmVariant = 'primary',
  cancelVariant = 'ghost',
  closeOnDimmerClick = true,
  closeOnEscape = true,
}) => {
  const contentStyle = getCustomModalContentStyle(classNameContent)

  useEffect(() => {
    if (!open || !closeOnEscape) return undefined
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [open, closeOnEscape, onClose])

  if (!open) return null

  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.tiny

  return createPortal(
    <div className={`custom-modal-portal ${classNamePortal || ''}`.trim()}>
      <div
        className="ui dimmer modals page active"
        onClick={closeOnDimmerClick ? onClose : undefined}
        role="presentation"
      />
      <div
        className={`ui modal custom-modal active ${sizeClass} ${classNameModal || ''}`.trim()}
        style={modalStyle}
        role="dialog"
        aria-modal="true"
        aria-labelledby="custom-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        {!hideHeader ? (
          <div className="header" id="custom-modal-title">
            {title}
          </div>
        ) : null}
        <div className={`content ${classNameContent || ''}`.trim()} style={contentStyle}>
          {content}
        </div>
        {!hideActions ? (
          <div className={`actions ${classNameActions || ''}`.trim()}>
            {customActions || (
              <ModalActionsFooter
                cancelLabel={cancelarLabel}
                onCancel={onClose}
                confirmLabel={confirmLabel}
                onConfirm={onConfirm}
                confirmDisabled={confirmDisabled}
                confirmLoading={isLoading}
                confirmVariant={confirmVariant}
                cancelVariant={cancelVariant}
              />
            )}
          </div>
        ) : null}
      </div>
    </div>,
    document.body,
  )
}

export default CustomModal
